// Очистка хранилища («Настройки» → «Общие»): пункты формы и сводка результата.
// Аналитика — звонки, оценки и выводы нод для дашборда — живёт в PostgreSQL (схема analytics),
// ClickHouse на стенде больше нет, и называть его в подписях значило бы обещать то, чего нет.

export const CLEANUP_OPTIONS = [
  {
    key: 'deleteOriginalFiles',
    label: 'Исходные файлы в S3',
    description: 'Загруженные записи звонков и вложения.'
  },
  {
    key: 'deleteTranscriptFiles',
    label: 'Файлы с расшифровками в S3',
    description: 'Тексты распознанной речи.'
  },
  {
    key: 'deleteAnalysisFiles',
    label: 'Файлы результатов в S3',
    description: 'JSON‑отчёты аналитики и выводов.'
  },
  {
    key: 'deleteAnalytics',
    label: 'Аналитика в PostgreSQL',
    description: 'Звонки, оценки и выводы анализа для дашборда.'
  },
  {
    key: 'deleteTasks',
    label: 'Задания в PostgreSQL',
    description: 'Очередь аналитических задач.'
  },
  {
    key: 'deleteClients',
    label: 'Клиенты в PostgreSQL',
    description: 'Справочник компаний и контактов.'
  },
  {
    key: 'deleteEmployees',
    label: 'Сотрудники в PostgreSQL',
    description: 'Карточки операторов и их статус.'
  }
];

export const CLEANUP_WARNING = 'Действие удалит выбранные данные в S3 и PostgreSQL.';

/** Сводка ответа POST /maintenance/storage/cleanup для уведомления; пустая строка — нечего сказать. */
export function describeCleanupResult(result) {
  return [
    result?.tasksDeleted ? `задания: ${result.tasksDeleted}` : null,
    result?.originalFilesDeleted ? `исходники: ${result.originalFilesDeleted}` : null,
    result?.transcriptFilesDeleted ? `расшифровки: ${result.transcriptFilesDeleted}` : null,
    result?.analysisFilesDeleted ? `аналитика (S3): ${result.analysisFilesDeleted}` : null,
    result?.clientsDeleted ? `клиенты: ${result.clientsDeleted}` : null,
    result?.employeesDeleted ? `сотрудники: ${result.employeesDeleted}` : null,
    result?.analyticsCleared ? 'аналитика в PostgreSQL очищена' : null
  ]
    .filter(Boolean)
    .join(', ');
}
